var React = require('react');
var helpers = require('svg-react-loader/helpers')(require('react-dom'));

module.exports = React.createClass({

    displayName: "SwitchOff",

    getDefaultProps () {
        return {"data-svgreactloader":"[[null,\"dc\",\"http://purl.org/dc/elements/1.1/\"],[null,\"cc\",\"http://creativecommons.org/ns#\"],[null,\"rdf\",\"http://www.w3.org/1999/02/22-rdf-syntax-ns#\"],[null,\"svg\",\"http://www.w3.org/2000/svg\"],[\"http://www.w3.org/2000/svg\",\"sodipodi\",\"http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd\"],[\"http://www.w3.org/2000/svg\",\"inkscape\",\"http://www.inkscape.org/namespaces/inkscape\"],[\"http://www.inkscape.org/namespaces/inkscape\",\"version\",\"1.0 (6e3e5246a0, 2020-05-07)\"],[\"http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd\",\"docname\",\"switch-off.svg\"]]","xmlns":"http://www.w3.org/2000/svg","width":"128","height":"64","viewBox":"0 0 33.866666 16.933334","version":"1.1","id":"svg8"};
    },

    componentDidMount () {
        helpers.applyXmlAttributes(this);
    },

    render () {
        var props = this.props;
        var children = props.children;

        return (
            <svg {...this.props}>
                  <defs id="defs2"/>
  <g data-svgreactloader="[[&quot;http://www.inkscape.org/namespaces/inkscape&quot;,&quot;label&quot;,&quot;Layer 1&quot;],[&quot;http://www.inkscape.org/namespaces/inkscape&quot;,&quot;groupmode&quot;,&quot;layer&quot;]]" id="layer1">
    <path data-svgreactloader="[[&quot;http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd&quot;,&quot;nodetypes&quot;,&quot;ssssssssssss&quot;],[null,&quot;style&quot;,&quot;color:#000000;overflow:visible;opacity:1;fill:#000000;stroke:none;stroke-width:1;stroke-opacity:0.988846;paint-order:markers fill stroke;stop-color:#000000&quot;]]" id="rect10-6" d="m 25.400001,1.0583334 c 4.104217,0 7.408333,3.3041164 7.408333,7.4083334 0,4.1042162 -3.304116,7.4083332 -7.408333,7.4083332 H 8.4666676 c -4.104218,0 -7.4083343,-3.304117 -7.4083343,-7.4083332 0,-4.104217 3.3041163,-7.4083334 7.4083343,-7.4083334 z M 8.4666676,3.1749994 c -2.922508,-10e-7 -5.291668,2.3691598 -5.291668,5.2916674 0,2.9225072 2.369161,5.2916672 5.291668,5.2916662 2.9225074,0 5.2916674,-2.369159 5.2916674,-5.2916662 0,-2.9225073 -2.36916,-5.2916674 -5.2916674,-5.2916674 z"/>
  </g>
                {React.Children.map(children, (c) => (c))}
            </svg>
        );
    }
});



// WEBPACK FOOTER //
// ./src/app/assets/switch-off.svg